// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   Tag,
//   Dropdown,
//   Menu,
//   message,
//   Spin,
//   Alert,
//   Modal,
//   Button,
// } from "antd";
// import {
//   EyeOutlined,
//   CloudDownloadOutlined,
//   MoreOutlined,
//   PlusOutlined,
// } from "@ant-design/icons";
// import axios from "axios";
// import "./PreAuthQueryCss.css";
// import { QueryData } from "../../../interfaces/IPreAuthQuery";
// import { useDispatch, useSelector } from "react-redux";
// import { AppDispatch, RootState } from "../../../store/store";
// import { fetchQueries } from "../../../models/preAuthQuerySlice";
// import { enhancementService } from "../../../apis/patientService";
// import { debug } from "console";
// import ReplyQueryModal from "./ReplyQueryModal";
// import AddPreAuthQueryModal from "./AddPreAuthQueryModal";
// import { text } from "stream/consumers";
// import { getPortalData } from "../../../models/preAuthSlice";
// interface QueryTableProps {
//   onfetchStepper: () => void; // Define prop type for the function
// }
//   const QueryTable: React.FC<QueryTableProps> = ({ onfetchStepper }) => {
//   // State management
//   const dispatch = useDispatch<AppDispatch>();
//   const [portalMetaDataId, setPortalMetaDataId] = useState<any>("");
//   const { data, status, error } = useSelector(
//     (state: RootState) => state.queries
//   );
//   const { patients, hospital } = useSelector((state: RootState) => state);
//   const [previewUrl, setPreviewUrl] = useState<string | null>(null);
//   const [selectedQuery, setSelectedQuery] = useState<QueryData | null>(null);
//   const [isAddQueryModalOpen, setIsAddQueryModalOpen] =
//     useState<boolean>(false);

//   useEffect(() => {
//     const fetchData = async () => {
//       if (status === "idle") {
//         const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
//         const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

//         let portalMetaDataId = null;

//         if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
//           try {
//             const portalMetaData = await enhancementService.getPortalMetaData(
//               patients.fetchBasicDetails.casesResponse.schemeMetaDataId
//             );
//             if (
//               portalMetaData.portalMetaDataIdsList &&
//               portalMetaData.portalMetaDataIdsList.length > 0
//             ) {
//               portalMetaDataId = portalMetaData.portalMetaDataIdsList[0];
//               setPortalMetaDataId(portalMetaDataId);
//             }
//           } catch (error) {
//             console.error("Error fetching portal metadata:", error);
//           }
//         }

//         if (caseId && visitId && portalMetaDataId) {
//           dispatch(fetchQueries({ caseId, visitId, portalMetaDataId }));
//         }
//       }
//     };

//     fetchData();
//   }, [
//     status,
//     dispatch,
//     patients?.fetchBasicDetails?.casesResponse?.id,
//     patients?.fetchBasicDetails?.visitInfoResponse?.id,
//   ]);

//   useEffect(()=>{
//     if (
//       patients?.fetchBasicDetails?.casesResponse?.id &&
//       patients?.fetchBasicDetails?.visitInfoResponse?.id
//     ) {
//       dispatch(
//         getPortalData({
//           caseId: patients?.fetchBasicDetails?.casesResponse?.id,
//           visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
//         })
//       );
//     }
//   },[
//     patients?.fetchBasicDetails?.casesResponse?.id,
//     patients?.fetchBasicDetails?.visitInfoResponse?.id
//   ])

//   // Handle menu actions
//   const handleMenuClick = (key: string, record: QueryData) => {
//     if (key === "reply") {
//       setSelectedQuery(record); // Set selected query to be passed to the modal
//       setIsReplyModalVisible(true); // Open the modal when reply is clicked
//     }
//   };

//   const handlePreviewDocument = (url: string) => {
//     // Assuming you want to open the URL in a new tab
//     // window.open(url, "_blank");

//     // Alternatively, if you want to display it in a modal:
//     setPreviewUrl(url);
//     showModal();
//   };

//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [isModalReplyVisible, setIsReplyModalVisible] = useState(false);
//   const showModal = () => setIsModalVisible(true);
//   const handleCancel = () => setIsModalVisible(false);

//   // Dropdown menu
//   const menu = (record: QueryData) => (
//     <Menu
//       onClick={(info) => handleMenuClick(info.key, record)}
//       items={[{ label: "Reply Query", key: "reply" }]}
//     />
//   );

//   // Column configuration
//   const columns = [
//     {
//       title: "Query Date/Time",
//       dataIndex: "createdAt",
//       key: "createdAt",
//       render: (text: string) => {
//         const date = new Date(text);

//         // Format day, month, and year
//         const day = String(date.getDate()).padStart(2, "0");
//         const monthNames = [
//           "Jan",
//           "Feb",
//           "Mar",
//           "Apr",
//           "May",
//           "Jun",
//           "Jul",
//           "Aug",
//           "Sep",
//           "Oct",
//           "Nov",
//           "Dec",
//         ];
//         const month = monthNames[date.getMonth()];
//         const year = date.getFullYear();

//         // Format hours, minutes, and seconds
//         const hours = String(date.getHours()).padStart(2, "0");
//         const minutes = String(date.getMinutes()).padStart(2, "0");
//         const seconds = String(date.getSeconds()).padStart(2, "0");

//         // Combine date and time in the desired format
//         const formattedDateTime = `${day} ${month}, ${year} ${hours}:${minutes}:${seconds}`;

//         return (
//           <div style={{ fontSize: "14px", color: "#333" }}>
//             {formattedDateTime}
//           </div>
//         );
//       },
//     },
//     {
//       title: "Query Received",
//       dataIndex: "receivedQuery",
//       key: "receivedQuery",
//       render: (text: string) => <div style={{ fontWeight: 500 }}>{text}</div>,
//     },
//     {
//       title: "Query Type",
//       dataIndex: "typeOfQuery",
//       key: "typeOfQuery",
//       render: (text: string) => <div style={{ fontSize: "14px" }}>{text}</div>,
//     },
//     {
//       title: "Assigned To",
//       dataIndex: "assignToFrontOffice",
//       key: "assignToFrontOffice",
//       render: (text: string) => (
//         <div style={{ fontSize: "14px" }}>
//           {text ? "Front Desk" : "Back Desk"}
//         </div>
//       ),
//     },
//     {
//       title: "Document Received",
//       key: "receivedDocumentUrl",
//       render: (text: any, record: QueryData) => (
//         <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
//           <EyeOutlined
//             style={{ fontSize: "16px", cursor: "pointer" }}
//             onClick={() => handlePreviewDocument(record.recievedDocumentUrl)} // Click handler
//           />
//           <CloudDownloadOutlined
//             style={{ fontSize: "16px", cursor: "pointer" }}
//           />
//         </div>
//       ),
//     },
//     {
//       title: "Query Status",
//       dataIndex: "stageStateDto",
//       key: "stageStateDto",
//       render: (stageStateDto: any) => {
//         const status =
//           stageStateDto?.stateName || stageStateDto?.stageName || "N/A"; // Fallback if both are null
//         let color = "";
//         let textColor = "";

//         switch (status) {
//           case "Replied":
//             color = "#0C6EFF33";
//             textColor = "#0C6EFF"; // Green
//             break;
//           case "Received":
//             color = "#D2691E33"; // Orange
//             textColor = "#D2691E";
//             break;
//           case "Query Case Closed":
//             color = "#13c2c2"; // Cyan
//             break;
//           default:
//             color = "#1890ff"; // Blue
//         }

//         return (
//           <span
//             style={{
//               fontWeight: 500,
//               fontSize: "14px",
//               padding: "4px 16px",
//               borderRadius: "9px",
//               color: textColor,
//               backgroundColor: color,
//             }}
//           >
//             {status}
//           </span>
//         );
//       },
//     },

//     {
//       title: "Action",
//       key: "action",
//       render: (text: any, record: QueryData) => {
//         const stageStateDto = record.stageStateDto || {};
//         const returnedResponse = record.returnedResponse || "";
//         const status =
//           stageStateDto?.stateName || stageStateDto?.stageName || "N/A"; // Extract the status

//         return status === "Replied" ? (
//           <div
//             style={{
//               fontSize: "14px",
//               fontWeight: 500,
//               color: "#28a745", // Green color for "Responded"
//               textAlign: "center",
//             }}
//           >
//             {returnedResponse}
//           </div>
//         ) : (
//           <div style={{ display: "flex", justifyContent: "center" }}>
//             <Dropdown overlay={menu(record)} trigger={["click"]}>
//               <MoreOutlined style={{ fontSize: "18px", cursor: "pointer" }} />
//             </Dropdown>
//           </div>
//         );
//       },
//     },
//     {
//       title: "Updated Date/Time",
//       dataIndex: "updatedAt",
//       key: "updatedAt",
//       render: (text: string) => {
//         const date = new Date(text);
//         // Format day, month, and year
//         const day = String(date.getDate()).padStart(2, "0");
//         const monthNames = [
//           "Jan",
//           "Feb",
//           "Mar",
//           "Apr",
//           "May",
//           "Jun",
//           "Jul",
//           "Aug",
//           "Sep",
//           "Oct",
//           "Nov",
//           "Dec",
//         ];
//         const month = monthNames[date.getMonth()];
//         const year = date.getFullYear();

//         // Format hours, minutes, and seconds
//         const hours = String(date.getHours()).padStart(2, "0");
//         const minutes = String(date.getMinutes()).padStart(2, "0");
//         const seconds = String(date.getSeconds()).padStart(2, "0");

//         // Combine date and time in the desired format
//         const formattedDateTime = `${day} ${month}, ${year} ${hours}:${minutes}:${seconds}`;

//         return (
//           <div style={{ fontSize: "14px", color: "#333" }}>
//             {formattedDateTime}
//           </div>
//         );
//       },
//     },
//     {
//       title: "Response Time",
//       dataIndex: "responseTime",
//       key: "responseTime",
//       render: (text: string) => (
//         <div style={{ fontSize: "14px", color: "#333", textAlign: "center" }}>
//           {text ? text : ""}{" "}{text? "Min" : ""}
//         </div>
//       ),
//     },
//   ];

//   if (status === "loading") {
//     return (
//       <Spin
//         size="large"
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "100%",
//         }}
//       />
//     );
//   }

//   if (status === "failed") {
//     return (
//       <Alert
//         message="Error"
//         description={error || "Failed to load queries"}
//         type="error"
//         style={{ margin: "20px" }}
//       />
//     );
//   }

//   const handleCancelForAddQuery = () => {
//     setIsAddQueryModalOpen(false);
//   };
//   // Main render
//   return (
//     <div style={{ padding: "14px" }}>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: "1rem",
//         }}
//       >
//         <h2 style={{ fontSize: "25px", fontWeight: "700" }}>Queries</h2>
//         <Button
//           icon={<PlusOutlined />}
//           onClick={() => setIsAddQueryModalOpen(true)}
//         >
//           ADD NEW Query
//         </Button>
//       </div>
//       <Table
//         columns={columns}
//         dataSource={data}
//         pagination={false}
//         className="custom-table"
//         bordered
//         style={{ boxShadow: "0 1px 3px rgba(0,0,0,0.1)", borderRadius: "8px" }}
//         onRow={(record, index: any) => ({
//           style: {
//             backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
//           },
//         })}
//       />
//       <AddPreAuthQueryModal
//         visible={isAddQueryModalOpen}
//         onCancel={handleCancelForAddQuery}
//         portalMetaDataId={portalMetaDataId}
//         onfetchStepper={onfetchStepper}
//       />

//       {selectedQuery && (
//         <ReplyQueryModal
//           visible={isModalReplyVisible}
//           setIsModalReplyVisible={setIsReplyModalVisible}
//           onCancel={() => setIsReplyModalVisible(false)}
//           query={selectedQuery} // Pass selected query data
//           portalMetaDataId={portalMetaDataId}
//         />
//       )}
//       <Modal
//         title="Document Preview"
//         visible={isModalVisible}
//         onCancel={handleCancel}
//         footer={null}
//         width={800}
//       >
//         {previewUrl ? (
//           <iframe
//             src={previewUrl}
//             width="100%"
//             height="400px"
//             title="Document Preview"
//           />
//         ) : (
//           <p>No document to preview</p>
//         )}
//       </Modal>
//     </div>
//   );
// };

// export default QueryTable;
import React, { useEffect, useState } from "react";
import {
  Table,
  Tag,
  Dropdown,
  Menu,
  message,
  Spin,
  Alert,
  Modal,
  Button,
  Tooltip,
} from "antd";
import {
  EyeOutlined,
  CloudDownloadOutlined,
  MoreOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import axios from "axios";
import "./PreAuthQueryCss.css";
import { QueryData } from "../../../interfaces/IPreAuthQuery";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { fetchQueries } from "../../../models/preAuthQuerySlice";
import { enhancementService } from "../../../apis/patientService";
import { debug } from "console";
import ReplyQueryModal from "./ReplyQueryModal";
import AddPreAuthQueryModal from "./AddPreAuthQueryModal";
import { text } from "stream/consumers";
import { getPortalData } from "../../../models/preAuthSlice";
import ViewResponseModal from "./ViewResponseModal";
import Loader from "../../../utils/Spinners";
interface QueryTableProps {
  onfetchStepper: () => void; // Define prop type for the function
}
const QueryTable: React.FC<QueryTableProps> = ({ onfetchStepper }) => {
  // State management
  const dispatch = useDispatch<AppDispatch>();
  const [portalMetaDataId, setPortalMetaDataId] = useState<any>("");
  const { data, status, error, loading } = useSelector(
    (state: RootState) => state.queries
  );
  const { patients, hospital } = useSelector((state: RootState) => state);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const [selectedQuery, setSelectedQuery] = useState<QueryData | null>(null);
  const [viewResponse, setIsViewResponse] = useState<QueryData | null>(null);
  const [isAddQueryModalOpen, setIsAddQueryModalOpen] =
    useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      if (status === "idle") {
        const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
        const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

        let portalMetaDataId = null;

        if (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId) {
          try {
            const portalMetaData = await enhancementService.getPortalMetaData(
              patients.fetchBasicDetails.casesResponse.schemeMetaDataId
            );
            if (
              portalMetaData.portalMetaDataIdsList &&
              portalMetaData.portalMetaDataIdsList.length > 0
            ) {
              portalMetaDataId = portalMetaData.portalMetaDataIdsList[0];
              setPortalMetaDataId(portalMetaDataId);
            }
          } catch (error) {
            console.error("Error fetching portal metadata:", error);
          }
        }

        // if (caseId && visitId && portalMetaDataId) {
        //   dispatch(fetchQueries({ caseId, visitId, portalMetaDataId }));
        // }
      }
    };

    fetchData();
  }, [
    status,
    dispatch,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      dispatch(
        getPortalData({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  // Handle menu actions
  const handleMenuClick = (key: string, record: QueryData) => {
    if (key === "reply") {
      setSelectedQuery({ ...record }); // Set selected query to be passed to the modal
      setIsReplyModalVisible(true); // Open the modal when reply is clicked
    }
  };

  const handleViewResponse = (record: QueryData) => {
    setIsViewResponse(record); // Set selected query to be passed to the modal
    setIsViewResponseModalVisible(true); // Open the modal when reply is clicked
  };

  const handlePreviewDocument = (url: string) => {
    // Assuming you want to open the URL in a new tab
    // window.open(url, "_blank");

    // Alternatively, if you want to display it in a modal:
    setPreviewUrl(url);
    showModal();
  };

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalReplyVisible, setIsReplyModalVisible] = useState(false);
  const [isViewResponseModalVisible, setIsViewResponseModalVisible] =
    useState(false);
  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);
  const handleModalClose = () => {
    setIsReplyModalVisible(false);
    setSelectedQuery(null); // Clear the selected query
  };

  // Dropdown menu
  const menu = (record: QueryData) => (
    <Menu
      onClick={(info) => handleMenuClick(info.key, record)}
      items={[{ label: "Reply Query", key: "reply" }]}
    />
  );

  // Column configuration
  const columns = [
    {
      title: "Query Date/Time",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text: string) => {
        const date = new Date(text);

        // Format day, month, and year
        const day = String(date.getDate()).padStart(2, "0");
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();

        // Format hours, minutes, and seconds
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        // Combine date and time in the desired format
        const formattedDateTime = `${day} ${month}, ${year} ${hours}:${minutes}:${seconds}`;

        return (
          <div style={{ fontSize: "14px", color: "#333" }}>
            {formattedDateTime}
          </div>
        );
      },
    },
    {
      title: "Query Received",
      dataIndex: "receivedQuery",
      key: "receivedQuery",
      render: (text: string) => <div style={{ fontWeight: 500 }}>{text}</div>,
    },
    {
      title: "Query Type",
      dataIndex: "typeOfQuery",
      key: "typeOfQuery",
      render: (text: string) => <div style={{ fontSize: "14px" }}>{text}</div>,
    },
    {
      title: "Assigned To",
      dataIndex: "assignToFrontOffice",
      key: "assignToFrontOffice",
      render: (text: string) => (
        <div style={{ fontSize: "14px" }}>
          {text ? "Front Desk" : "Back Desk"}
        </div>
      ),
    },
    {
      title: "Document Received",
      key: "receivedDocumentUrl",
      render: (text: any, record: QueryData) => (
        <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
          <EyeOutlined
            style={{ fontSize: "16px", cursor: "pointer" }}
            onClick={() => handlePreviewDocument(record.recievedDocumentUrl)} // Click handler
          />
          <CloudDownloadOutlined
            style={{ fontSize: "16px", cursor: "pointer" }}
          />
        </div>
      ),
    },
    {
      title: "Query Status",
      dataIndex: "stageStateDto",
      key: "stageStateDto",
      render: (stageStateDto: any) => {
        const status =
          stageStateDto?.stateName || stageStateDto?.stageName || "N/A"; // Fallback if both are null
        let color = "";
        let textColor = "";

        switch (status) {
          case "Replied":
            color = "#0C6EFF33";
            textColor = "#0C6EFF"; // Green
            break;
          case "Received":
            color = "#D2691E33"; // Orange
            textColor = "#D2691E";
            break;
          case "Query Case Closed":
            color = "#13c2c2"; // Cyan
            break;
          default:
            color = "#1890ff"; // Blue
        }

        return (
          <span
            style={{
              fontWeight: 500,
              fontSize: "14px",
              padding: "4px 16px",
              borderRadius: "9px",
              color: textColor,
              backgroundColor: color,
            }}
          >
            {status}
          </span>
        );
      },
    },

    {
      title: "Action",
      key: "action",
      render: (text: any, record: QueryData) => {
        const stageStateDto = record.stageStateDto || {};
        const returnedResponse = record.returnedResponse || "";
        const status =
          stageStateDto?.stateName || stageStateDto?.stageName || "N/A"; // Extract the status

        return status === "Replied" ? (
          // <div
          //   style={{
          //     fontSize: "14px",
          //     fontWeight: 500,
          //     color: "#28a745", // Green color for "Responded"
          //     textAlign: "center",
          //   }}
          // >
          //   {returnedResponse}
          // </div>
          <Tooltip title="View Response">
            <div
              style={{
                textAlign: "center",
              }}
              onClick={() => handleViewResponse(record)}
            >
              <EyeOutlined style={{ fontSize: "15px", cursor: "pointer" }} />
            </div>
          </Tooltip>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Dropdown overlay={menu(record)} trigger={["click"]}>
              <MoreOutlined style={{ fontSize: "18px", cursor: "pointer" }} />
            </Dropdown>
          </div>
        );
      },
    },
    {
      title: "Updated Date/Time",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (text: string) => {
        const date = new Date(text);
        // Format day, month, and year
        const day = String(date.getDate()).padStart(2, "0");
        const monthNames = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();

        // Format hours, minutes, and seconds
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        // Combine date and time in the desired format
        const formattedDateTime = `${day} ${month}, ${year} ${hours}:${minutes}:${seconds}`;

        return (
          <div style={{ fontSize: "14px", color: "#333" }}>
            {formattedDateTime}
          </div>
        );
      },
    },
    {
      title: "Response Time",
      dataIndex: "responseTime",
      key: "responseTime",
      render: (text: string) => (
        <div style={{ fontSize: "14px", color: "#333", textAlign: "center" }}>
          {text ? text : ""} {text ? "Min" : ""}
        </div>
      ),
    },
  ];

  if (status === "loading") {
    return (
      <Spin
        size="large"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      />
    );
  }

  if (status === "failed") {
    return (
      <Alert
        message="Error"
        description={error || "Failed to load queries"}
        type="error"
        style={{ margin: "20px" }}
      />
    );
  }

  const handleCancelForAddQuery = () => {
    setIsAddQueryModalOpen(false);
  };
  // Main render
  return (
    <div style={{ padding: "14px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <h2 style={{ fontSize: "25px", fontWeight: "700" }}>Queries</h2>
        <Button
          icon={<PlusOutlined />}
          onClick={() => setIsAddQueryModalOpen(true)}
        >
          ADD NEW Query
        </Button>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          className="custom-table"
          bordered
          style={{
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            borderRadius: "8px",
          }}
          onRow={(record, index: any) => ({
            style: {
              backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
            },
          })}
        />
      )}
      <AddPreAuthQueryModal
        visible={isAddQueryModalOpen}
        onCancel={handleCancelForAddQuery}
        portalMetaDataId={portalMetaDataId}
        onfetchStepper={onfetchStepper}
      />

      {selectedQuery && (
        <ReplyQueryModal
          visible={isModalReplyVisible}
          setIsModalReplyVisible={setIsReplyModalVisible}
          onCancel={handleModalClose}
          query={selectedQuery} // Pass selected query data
          portalMetaDataId={portalMetaDataId}
          setSelectedQuery={setSelectedQuery}
        />
      )}
      {viewResponse && (
        <ViewResponseModal
          visible={isViewResponseModalVisible}
          setIsModalReplyVisible={setIsViewResponseModalVisible}
          onCancel={() => setIsViewResponseModalVisible(false)}
          query={viewResponse} // Pass selected query data
          portalMetaDataId={portalMetaDataId}
        />
      )}
      <Modal
        title="Document Preview"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={800}
      >
        {previewUrl ? (
          <iframe
            src={previewUrl}
            width="100%"
            height="400px"
            title="Document Preview"
          />
        ) : (
          <p>No document to preview</p>
        )}
      </Modal>
    </div>
  );
};

export default QueryTable;
